import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {Question} from '../../models/question.model';
import {ControlPanelService} from '../../services/controlPanel.service';
import {loadingWrap} from '../../rxjs/rx_loading';

@Component({
  selector: 'app-number-cp-custom',
  templateUrl: './number-cp-custom.component.html',
  styleUrls: ['./number-cp-custom.component.scss'],
})
export class NumberCpCustomComponent implements OnInit, OnChanges {
    @Input() question: Question;
    @Input() idx: number;
    @Input() data: any;
    @Input() totalApp: number;
    @Input() statistic: boolean;
    @Input() loopCount: number;
    @Input() checkControlPanel: any;
    @Input() isViewResult;
    @Output() getFull = new EventEmitter<any>();
    @Output() getValue = new EventEmitter();
    @Output() getAllResult = new EventEmitter();
    higher8Years: string;
    numberApp: number;
    minValue = 0;
    maxValue = 36;
    minYear: number;
    minMonth: number;
    maxYear: number;
    maxMonth: number;
    answerLowest: number;
    answerHighest: number;
    answerMinYear: number;
    answerMinMonth: number;
    answerMaxYear: number;
    answerMaxMonth: number;
    applicantsFulfill: number;
    highest: number;
    lowest: number;
    sliderRange: number[] = [this.minValue, this.maxValue];
    sliderConfig: any = {
        connect: true,
        limit: this.maxValue,
        range: {
            min: this.minValue,
            max: this.maxValue
        },
        pips: {
            mode: 'range',
            density: 3
        }
    };
    score = 0;
    idData: number;
    minLimit = 0;
    maxLimit = 0;
    formatInputText?: string;

    constructor(private controlPanelService: ControlPanelService) { }

    ngOnInit() {
        if (this.checkControlPanel != null) {
          this.statistic = true;
        }
        if (this.question['hightest'] === null && this.question['lowest'] === null) {
          this.question['hightest'] = this.question['lowest'] = 0;
        }
        this.settingSlider();
        for (const item of this.data) {
            if (item['question_id'] === this.question.id) {
                this.sliderRange[0] = item['min'];
                this.sliderRange[1] = item['max'];
                this.answerLowest = item['lowest'];
                this.answerHighest = item['highest'];
                this.minYear = Math.floor(item['min'] / 12);
                this.minMonth = item['min'] % 12;
                this.maxYear = Math.floor(item['max'] / 12);
                this.maxMonth = item['max'] % 12;
                this.answerMinYear = Math.floor(item['lowest'] / 12);
                this.answerMinMonth = item['lowest'] % 12;
                this.answerMaxYear = Math.floor(item['highest'] / 12);
                this.answerMaxMonth = item['highest'] % 12;
                this.score = item['score'];
                this.idData = item['id'];
                this.applicantsFulfill = item['applicants_fulfill'];
                this.lowest = item['lowest'];
                this.highest = item['highest'];
            }
        }
        this.getAppNumbers();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loopCount && this.loopCount > 0) {
            this.getAppNumbers();
        }
    }

    onGetAllResult() {
        this.getAllResult.emit();
    }

    getAppNumbers() {
      const result = {
        min: this.question['note'] === 'years' && this.higher8Years ? this.minLimit * 12 : this.minLimit,
        max: this.question['note'] === 'years' && this.higher8Years ? this.maxLimit * 12 : this.maxLimit,
        note: this.question['note'],
      };
      this.controlPanelService.getApplicansNumber(this.question.id, result.min, result.max, result.note).pipe(loadingWrap()).subscribe(res => {
      this.numberApp = res.results.length;
      if (this.score < 0 ) {
        this.score = 0;
      }
      if (this.score > 99) {
        this.score = 99;
      }
      const data = {
        id: this.idData,
        question_id: this.question.id,
        type: this.question.type,
        min: this.question['note'] === 'years' && this.higher8Years ? this.minLimit * 12 : this.minLimit,
        max: this.question['note'] === 'years' && this.higher8Years ? this.maxLimit * 12 : this.maxLimit,
        note: this.question['note'],
        highest: this.question['hightest'],
        lowest: this.question['lowest'],
        score: this.score,
        higher8Years: this.higher8Years,
        applicants_fulfill: this.numberApp
      };
      if (typeof this.data !== 'undefined' && this.data.length > 0) {
        for (const item of this.data) {
          if (item['question_id'] == this.question.id) {
            data.id = item['id'];
          }
        }
      }
      this.getFull.emit(data);
  }
);
    }

    settingSlider() {
        if (this.question['hightest'] <= 96) {
          if (this.question['note'] === 'years') {
            this.formatInputText = 'years';
            this.sliderRange[0] = this.minLimit = Math.floor(this.question['lowest'] / 12);
            this.sliderRange[1] = this.maxLimit = Math.round(this.question['hightest'] / 12);
            this.sliderConfig.limit = this.sliderConfig.range.max = 36;
          } else {
            this.formatInputText = 'months';
            this.sliderConfig.range.max = 96;
            this.sliderConfig.limit = 96;
            this.sliderRange[0] = this.minLimit = this.minValue = this.question['lowest'];
            this.sliderRange[1] = this.maxLimit = this.maxValue = this.question['hightest'];
          }
        } else if (this.question['hightest'] > 96) {
            if (this.question['note'] === 'years') {
                this.higher8Years = this.formatInputText = 'years';
                this.minLimit = this.minValue = this.sliderRange[0] = Math.floor(this.question['lowest'] / 12);
                this.maxLimit = this.maxValue = this.sliderRange[1] = this.sliderConfig.limit = this.sliderConfig.range.max = Math.round(this.question['hightest'] / 12 + 0.5);
            } else {
                this.minLimit = this.minValue = this.question['lowest'];
                this.maxLimit = this.maxValue = this.question['hightest'];
                this.formatInputText = 'months';
                if (this.question['hightest'] > 96 && this.question['note'] !== 'other' + 0.5) {
                    this.sliderRange[0] = Math.floor(this.question['lowest'] / 12);
                    this.sliderRange[1] = Math.round(this.question['hightest'] / 12 + 0.5);
                    this.higher8Years = 'years';
                    this.sliderConfig.range.max = 36;
                    this.sliderConfig.limit = 36;
                } else {
                  this.sliderConfig.range.max = 96;
                    this.sliderConfig.limit = 96;
                    this.sliderRange[0] = this.question['lowest'];
                    this.sliderRange[1] = this.question['hightest'];
                }
            }
        }
    }

  changeSlider($event: any, question: Question) {
    if (question['hightest'] <= 96) {
      this.minLimit = $event[0];
      this.maxLimit = $event[1];
    } else {
      if (question['note'] === 'years') {
        this.minLimit = $event[0];
        this.maxLimit = $event[1];
      } else {
        this.minLimit = $event[0] * 12;
        this.maxLimit = $event[1] * 12;
      }
    }
  }
}
